// @flow
export const TOAST_VISIBLE_FOR: number = 4000; // in milliseconds
export const TOAST_CONTEXT_SUCCESS: string = 'SUCCESS';
export const TOAST_CONTEXT_ERROR: string = 'ERROR';
